import script from "./DualFrameLayout.vue?vue&type=script&setup=true&lang=js"
export * from "./DualFrameLayout.vue?vue&type=script&setup=true&lang=js"

import "./DualFrameLayout.vue?vue&type=style&index=0&id=63a8d50c&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-63a8d50c"]])

export default __exports__